const messages = {
  title: "Údržba!",
  description:
    'Na serverech právě probíhají nezbytné údržbové práce.<br/><br/>Proto je přístup k <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> momentálně nedostupný.<br/><br/>Děkujeme za vaši trpělivost a pochopení.<br/><br/> Váš tým Bridgestone',
}
export default {
  messages
}
